import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function AddStatutory() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [countries, setCountries] = useState([]);
  const [acts, setActs] = useState([]);

  const [country, setCountry] = useState("");
  const [act, setAct] = useState("");

  const [errors, setErrors] = useState({});
  const [errorVisible, setErrorVisible] = useState(false);

  const navigate = useNavigate();

  /* =========================
     Error fade-out handling
  ========================= */
  useEffect(() => {
    if (errors.api) {
      setErrorVisible(true);
      const timer = setTimeout(() => setErrorVisible(false), 4500);
      const clearTimer = setTimeout(() => setErrors({}), 5000);

      return () => {
        clearTimeout(timer);
        clearTimeout(clearTimer);
      };
    }
  }, [errors.api]);

  /* =========================
     Fetch Countries
  ========================= */
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await apiFetch("/compliance/countries");
        setCountries(res?.countries || []);
        setCountry(""); // keep "Select"
      } catch (err) {
        console.error("Country fetch failed:", err);
        setCountries([]);
        setErrors({ api: "Failed to load countries" });
      }
    };

    fetchCountries();
  }, []);

  /* =========================
     Fetch Acts (on country change)
  ========================= */
  useEffect(() => {
    if (!country) {
      setActs([]);
      setAct("");
      return;
    }

    const fetchActs = async () => {
      try {
        const res = await apiFetch(
          `/compliance/acts?country=${encodeURIComponent(country)}`
        );
        setActs(res?.acts || []);
        setAct("");
      } catch (err) {
        console.error("Act fetch failed:", err);
        setActs([]);
        setErrors({ api: "Failed to load acts" });
      }
    };

    fetchActs();
  }, [country]);

  /* =========================
     Submit handler
  ========================= */
  const handleFilter = (e) => {
    e.preventDefault();
    setErrors({});

    if (!country) {
      setErrors({ api: "Country is required" });
      return;
    }

    if (!act) {
      setErrors({ api: "Act is required" });
      return;
    }

    localStorage.setItem("selectedCountry", country);
    localStorage.setItem("selectedAct", act);

    navigate("/statutory_info");
  };
  return (
    <div className="add-statutory">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main style={{ flex: 1, padding: "1rem 2rem", overflowY: "auto" }}>
          <h2>Add Statutory</h2>

          {/* SAME MESSAGE UI AS AddUser */}
         <div
  className="messages-top"
  style={{
    margin: "0 auto 1rem auto",
    width: "50%",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  }}
>
  {errors.api && (
    <div className={`login-error ${!errorVisible ? "fade-out" : ""}`}>
      {errors.api}
    </div>
  )}
</div>


          <form onSubmit={handleFilter} className="add-user-form">
            <label>
              Select Country
              <select
  name="country"
  value={country}
  onChange={(e) => setCountry(e.target.value)}
>
  <option value="" disabled>
    Select
  </option>

  {countries.map((c, i) => (
    <option key={i} value={c}>
      {c}
    </option>
  ))}
</select>

            </label>

            <label>
              Select Act
              <select
                name="act"
                value={act}
                onChange={(e) => setAct(e.target.value)}
              >
                {acts.length === 0 ? (
                  <option value="">No act found</option>
                ) : (
                  <>
                    <option value="">Select</option>
                    {acts.map((a, i) => (
                      <option key={i} value={a}>
                        {a}
                      </option>
                    ))}
                  </>
                )}
              </select>
            </label>

            <label>
              <button type="submit" className="submit-btn">
                Filter
              </button>
            </label>

<br/>
            <label>
              <a
                href="/NotFound"
                style={{ color: "red", textDecoration: "none", paddingTop: "10px" }}
              >
                Compliance not found?
              </a>
            </label>
          </form>
        </main>
      </div>
    </div>
  );
}
